module.exports = __webpack_public_path__ + "img/mind_icon_number_7.7360bed2.png";